/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function NotEqualIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M29.313 6.312c.687.438.875 1.375.375 2.063L26.563 13H31.5c.813 0 1.5.687 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-7l-5.437 8H31.5c.813 0 1.5.687 1.5 1.5 0 .875-.687 1.5-1.5 1.5H17l-4.312 6.375a1.435 1.435 0 0 1-2.063.375 1.435 1.435 0 0 1-.375-2.063L13.375 27H8.5c-.875 0-1.5-.625-1.5-1.5 0-.813.625-1.5 1.5-1.5h6.938l5.437-8H8.5c-.875 0-1.5-.625-1.5-1.5 0-.813.625-1.5 1.5-1.5h14.438l4.312-6.313a1.435 1.435 0 0 1 2.063-.375"/>}
        </IconWrapper>);
}
